import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { withNavigation } from "../../../tools/Tools";

const TopBarContainer = styled.div`
	position: sticky;
	top: 0;
	left: 0;
	width: 100%;
	height: 64px;
	background: var(--color-surface);
	z-index: ${(props) => (props.isLifted ? "2" : "0")};
	-webkit-user-select: none;
	user-select: none;

	@media (max-width: 400px) {
		width: 100vw;
		margin-left: -24px;
	}
`;

const TopBarContent = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
	width: 100%;
	height: 64px;
	padding: 0 16px;
	background: ${(props) =>
		props.isLifted
			? "rgba(from var(--color-surface-tint) r g b / 20%)"
			: "var(--color-surface)"};
	color: var(--color-on-surface);
	transition: 0.3s;
`;

const BackButton = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: transparent;
	transition: 0.3s;
	cursor: pointer;

	&:hover {
		background: var(--color-surface-container-highest);
	}
`;

const TopTitle = styled.h1`
	flex: 1 1 auto;
	text-align: ${(props) => (props.isCentred ? "center" : "left")};
	font-style: var(--md-sys-typescale-title-large-font-family-style);
	font-weight: var(--md-sys-typescale-title-large-font-weight);
	font-size: var(--md-sys-typescale-title-large-font-size);
	letter-spacing: var(--md-sys-typescale-title-large-tracking);
	line-height: var(--md-sys-typescale-title-large-height);
	text-transform: var(--md-sys-typescale-title-large-text-transform);
	text-decoration: var(--md-sys-typescale-title-large-text-decoration);
`;

const TrailingIcons = styled.div`
	width: 36px;
	height: 36px;
`;

class TopNavBarComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLifted: false,
		};

		this.handleScroll = this.handleScroll.bind(this);
	}

	componentDidMount() {
		window.addEventListener("scroll", this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
	}

	handleScroll() {
		if (window.scrollY >= 24 && !this.state.isLifted) {
			this.setState({
				isLifted: true,
			});
		} else if (window.scrollY < 24) {
			this.setState({
				isLifted: false,
			});
		}
	}

	goBack = () => {
		this.props.navigate(-1);
	};

	render() {
		return (
			<TopBarContainer isLifted={this.state.isLifted}>
				<TopBarContent isLifted={this.state.isLifted}>
					{this.props.goBack && (
						<BackButton onClick={this.goBack}>
							<span className="material-symbol fill">
								arrow_back_ios_new
							</span>
						</BackButton>
					)}
					<TopTitle isCentred={this.props.centredTitle}>
						{this.props.title}
					</TopTitle>
					{this.props.goBack && <TrailingIcons></TrailingIcons>}
				</TopBarContent>
			</TopBarContainer>
		);
	}
}

TopNavBarComponent.propTypes = {
	title: PropTypes.string,
	goBack: PropTypes.bool,
	centredTitle: PropTypes.bool,
};

TopNavBarComponent.defaultProps = {
	title: "",
	goBack: false,
	centredTitle: false,
};

export default withNavigation(TopNavBarComponent);
